import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/users/current']['get']['responses']['200']['content']['application/json'];

export const getProfile = async () => apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.user.current);
